export function authHeaders() {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return [{ 'x-auth-token': user.token }];
    // return { Authorization: "Bearer " + user.token };
  }
  return [];
}

export function getUserPermissionsToken() {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.userPermissionsToken) {
    return user.userPermissionsToken;
  }
}

export function setUserPermissionsToken(userPermissionsToken) {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && userPermissionsToken) {
    user.userPermissionsToken = userPermissionsToken;
    localStorage.setItem('user', JSON.stringify(user));
    return user.userPermissionsToken;
  }
}

export function updateUserLocalStorage(user = null) {
  if (user) {
    const prevUserData = JSON.parse(localStorage.getItem('user'));
    if (prevUserData) {
      const updatedUserData = {
        ...prevUserData,
        ...user
      };
      localStorage.setItem('user', JSON.stringify(updatedUserData));
    }
  }
}
